import logoImage from '@assets/images/logo-facturalibre.png';

interface LogoProps {
  className?: string;
  width?: number;
  height?: number;
  showText?: boolean;
}

export function Logo({ className = '', width, height, showText = false }: LogoProps) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <img
        src={logoImage}
        alt="Factura Libre"
        width={width}
        height={height}
        className="object-contain"
      />
      {showText && (
        <span className="text-2xl font-bold text-primary-600">FacturaLibre</span>
      )}
    </div>
  );
}
